export const actionTypes = {
    setParams : 'SET_PARAMS_LIQUIDATION',
    sendToBill : 'SEND_TO_BILL_LIQUIDATIONS',
    selectLiquidations:'SELECT_LIQUIDATIONS',
    fetchLiquidations : 'FETCH_LIQUIDATIONS',
    receiveLiquidations : 'RECEIVE_LIQUIDATIONS',
    clearLiquidations : 'CLEAR_LIQUIDATIONS',
};
